import { render, staticRenderFns } from "./com-title.vue?vue&type=template&id=65a808c7&scoped=true"
import script from "./com-title.vue?vue&type=script&lang=js"
export * from "./com-title.vue?vue&type=script&lang=js"
import style0 from "./com-title.vue?vue&type=style&index=0&id=65a808c7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a808c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a808c7')) {
      api.createRecord('65a808c7', component.options)
    } else {
      api.reload('65a808c7', component.options)
    }
    module.hot.accept("./com-title.vue?vue&type=template&id=65a808c7&scoped=true", function () {
      api.rerender('65a808c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-title.vue"
export default component.exports